import { useQuery } from "@tanstack/react-query";
import { fetchAllMarkets } from "@/api/hip3";
import { hip3QueryKeys } from "./hip3-query-keys";

export function useHip3Markets() {
  return useQuery({
    queryKey: hip3QueryKeys.markets(),
    queryFn: ({ signal }) => fetchAllMarkets({ signal }),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    retry: 1,
    retryDelay: 1_500,
  });
}
